export const GET_TERMINAL_DEF= "GET_TERMINAL_DEF"
export const GET_TERMINAL_DEF_SUCCESS = "GET_TERMINAL_DEF_SUCCESS"
export const GET_TERMINAL_DEF_FAIL = "GET_TERMINAL_DEF_FAIL"

export const TERMINAL_DEF_API_ERROR = "API_ERROR"